import { Product } from '@/features/products/shared';
import { CategoryModel, MasterDataModel } from '@/models';

/**
 * Props
 */

/**
 * Models
 */

export interface Category extends CategoryModel {
  seo: any;
}

export type MasterData = MasterDataModel;

/**
 * Query
 */

export type ProductsQueryPayload = {
  offset: number;
  limit: number;
  gem_size?: string;
  gem_type?: string;
  gem_material?: string;
  product_keyword?: string;
  cat_code?: string;
  price?: string;
  tags?: string;
  quotation?: boolean;
  is_partner?: boolean;
  partner_id?: number;
  sort_by?: string;
};
export type RelatedProductsQueryPayload = {
  offset?: number;
  limit?: number;
  cat_code: string;
  product_id?: number;
};
export type ProductsQueryResponse = { data: Product[]; total_records: number };
export type ProductsRelatedQueryResponse = { data: Product[] };
export type CategoriesQueryResponse = { data: CategoryModel[] };
/**
 * Const
 */

export enum ReducerType {
  OnPageChange = 'OnPageChange',
  OnColorChange = 'OnColorChange',
  OnFilterReset = 'OnFilterReset',
  OnGemTypeChange = 'OnGemTypeChange',
  OnGemPureChange = 'OnGemPureChange',
  OnKeywordChange = 'OnKeywordChange',
  OnCategoryChange = 'OnCategoryChange',
  OnGemMaterialChange = 'OnGemMaterialChange',
  OnAllChange = 'OnAllChange',
  OnJewelryMaterialChange = 'OnJewelryMaterialChange',
  OnPriceChange = 'OnPriceChange',
  OnTagChange = 'OnTagChange',
  OnQuotationChange = 'OnQuotationChange',
  OnSortBy = 'OnSortBy',
}
export enum KeyFilter {
  Color = 'color',
  GemMaterial = 'gem_material',
  JewelryMaterial = 'jewelry_material',
  GemType = 'gem_type',
  GemPure = 'gem_pure',
  Price = 'price',
  Quotation = 'quotation',
  SortBy = 'sort_by',
}
export type ReducerTypes = {
  limit: number;
  color: string;
  offset: number;
  cat_code: string;
  gem_type: string;
  gem_pure: string;
  gem_material: string;
  product_keyword: string;
  jewelry_material: string;
  price: string;
  tags: string;
  quotation: string;
  sort_by: string;
};

export type cursorTypes = { edges: Product[]; count: number };

export type InitMasterDataTypes = {
  color: string[];
  gem_type: string[];
  gem_material: string[];
  jewelry_material: string[];
  gem_pure: string[];
};
export type InitMasterDataCustomTypes = {
  color: string[];
  gem_type: string[];
};
/**
 * default !value
 */

export const CategoryDefault = 'MOI';

export const ProductInputKeys = ['gem_material', 'jewelry_material', 'gem_pure', 'gem_type', 'color'];

export const CursorDefault = { edges: [], count: 0 };

export const priceFilter = [
  { value: '', text: 'Tất cả' },
  { value: '0,10000000', text: 'Dưới 10 triệu' },
  { value: '10000001,40000000', text: 'Từ 10 đến 40 triệu' },
  { value: '40000001,80000000', text: 'Từ 40 đến 80 triệu' },
  { value: '80000001,100000000000', text: 'Trên 80 triệu' },
  { value: 'true', text: 'Liên hệ' },
];
